/**
 * CSV アップロードの gzip 圧縮ユーティリティ。
 *
 * 198MB / 3.5M 行クラスの CSV では、ブラウザ側で gzip 圧縮してから GCS へ PUT することで
 * 転送量が 1/3 程度に下がり、アップロードとサーバー側の初期ロード(loadCsv)の双方が短縮される。
 * 圧縮は `CompressionStream`(ブラウザ標準)で行うため追加依存は不要。
 */

/** これ未満のサイズでは圧縮の CPU コストに見合わないため圧縮しない (1MiB)。 */
export const GZIP_MIN_BYTES = 1024 * 1024;

/** gzip を保存したオブジェクトの content-type。GCS には Content-Encoding を付けず生バイトとして保存する。 */
export const GZIP_CONTENT_TYPE = 'application/gzip';

/** content_encoding の値 (FileMetadata / 読み取り側の gunzip 判定キー)。 */
export const GZIP_CONTENT_ENCODING = 'gzip';

/** ブラウザが gzip 圧縮に対応しているか (CompressionStream の有無)。 */
export const isGzipSupported = (): boolean => typeof CompressionStream !== 'undefined';

/**
 * File を gzip 圧縮した Blob に変換する。
 * ストリーミング圧縮なので、巨大ファイルでも全量を一度にメモリへ載せない。
 */
export const gzipFile = async (file: File): Promise<Blob> => {
  const compressed = file.stream().pipeThrough(new CompressionStream('gzip'));
  return await new Response(compressed).blob();
};
